/* =========================================================
   COMFORT THEME — theme.js
   Vanilla JS, sans dépendance. Chargé en `defer`.
   ========================================================= */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const on = (el, evt, fn, opts) => el && el.addEventListener(evt, fn, opts);

  /* ---------- 1. Header sticky : ombre au scroll ---------- */
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 1b. Bandeau d'annonce coulissant ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const slides = $$('[data-ann-slide]', bar);
    if (slides.length < 2) return;
    let idx = 0;
    setInterval(() => {
      slides[idx].classList.remove('is-active');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('is-active');
    }, 4000);
  });

  /* ---------- 2. Overlay partagé ---------- */
  let overlay = $('.overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'overlay';
    document.body.appendChild(overlay);
  }
  const closeAll = () => {
    $$('.mobile-nav.is-open, .cart-drawer.is-open, .facets.is-open').forEach((el) => el.classList.remove('is-open'));
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  };
  on(overlay, 'click', closeAll);
  on(document, 'keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  const openPanel = (panel) => {
    if (!panel) return;
    panel.classList.add('is-open');
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  };

  /* ---------- 3. Menu mobile ---------- */
  on($('[data-menu-open]'), 'click', () => openPanel($('.mobile-nav')));
  $$('[data-menu-close]').forEach((b) => on(b, 'click', closeAll));

  /* ---------- 4. Filtres mobile (drawer) ---------- */
  on($('[data-facets-open]'), 'click', () => openPanel($('.facets')));
  on($('[data-facets-close]'), 'click', closeAll);

  /* ---------- 5. Panier (drawer + AJAX) ---------- */
  const cartDrawer = () => $('.cart-drawer');

  const updateCartCount = (count) => {
    $$('.cart-count').forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
    });
  };

  // Remplace le contenu du drawer à partir d'une section re-rendue côté serveur
  const renderDrawerFromSection = (html) => {
    const drawer = cartDrawer();
    if (!drawer || !html) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector('[data-cart-drawer-inner]');
    const target = drawer.querySelector('[data-cart-drawer-inner]');
    if (fresh && target) target.innerHTML = fresh.innerHTML;
    const count = fresh ? parseInt(fresh.getAttribute('data-cart-count') || '0', 10) : 0;
    updateCartCount(count);
  };

  const openCartDrawer = () => {
    const d = cartDrawer();
    if (!d) { window.location.href = '/cart'; return; }
    closeAll();
    openPanel(d);
  };

  // Ouvrir le drawer via l'icône panier
  $$('[data-cart-open]').forEach((b) => on(b, 'click', (e) => {
    if (!cartDrawer()) return; // fallback : laisse le lien aller vers /cart
    e.preventDefault();
    openCartDrawer();
  }));
  $$('[data-cart-close]').forEach((b) => on(b, 'click', closeAll));

  // Ajout au panier (formulaire produit)
  const sectionsToRender = ['cart-drawer'];
  $$('form[data-product-form]').forEach((form) => {
    on(form, 'submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      const formData = new FormData(form);
      const body = { items: [{}], sections: sectionsToRender, sections_url: window.location.pathname };
      body.items[0].id = formData.get('id');
      body.items[0].quantity = parseInt(formData.get('quantity') || '1', 10);
      try {
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Erreur panier');
        if (data.sections && data.sections['cart-drawer']) renderDrawerFromSection(data.sections['cart-drawer']);
        openCartDrawer();
      } catch (err) {
        console.error(err);
        form.submit(); // fallback non-JS
      } finally {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      }
    });
  });

  // Modifier la quantité / retirer une ligne dans le drawer ou la page panier
  const changeCartLine = async (key, quantity) => {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: sectionsToRender, sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (data.sections && data.sections['cart-drawer']) renderDrawerFromSection(data.sections['cart-drawer']);
    // Page panier : recharger pour refléter les totaux
    if (document.body.classList.contains('template-cart')) window.location.reload();
  };

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeCartLine(remove.getAttribute('data-key'), 0); return; }
    const step = e.target.closest('[data-cart-qty]');
    if (step) {
      e.preventDefault();
      const key = step.getAttribute('data-key');
      const dir = parseInt(step.getAttribute('data-cart-qty'), 10);
      const current = parseInt(step.getAttribute('data-current') || '1', 10);
      changeCartLine(key, Math.max(0, current + dir));
    }
  });

  /* ---------- 6. Sélecteur de quantité (page produit) ---------- */
  $$('[data-qty-selector]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-step]').forEach((btn) => {
      on(btn, 'click', () => {
        const dir = parseInt(btn.getAttribute('data-qty-step'), 10);
        const val = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
        input.value = val;
      });
    });
  });

  /* ---------- 7. Sélecteur de variantes ---------- */
  $$('[data-product-form]').forEach((form) => {
    const dataEl = form.querySelector('[data-variant-json]');
    if (!dataEl) return;
    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (_) { return; }
    const idInput = form.querySelector('input[name="id"]');
    const priceTarget = $('[data-product-price]');
    const addBtn = form.querySelector('[data-add-to-cart]');
    const addBtnText = addBtn && addBtn.querySelector('[data-add-text]');

    const optionInputs = () => $$('.variant-options input:checked', form);

    // Filtre la galerie pour n'afficher que les photos de la couleur choisie
    const filterGalleryByColor = (color) => {
      const thumbs = $$('[data-thumb]');
      if (!thumbs.length) return;
      let firstVisible = null;
      thumbs.forEach((t) => {
        const tc = t.getAttribute('data-color');
        const show = !color || !tc || tc === color;
        t.style.display = show ? '' : 'none';
        if (show && !firstVisible) firstVisible = t;
      });
      if (firstVisible) {
        const img = firstVisible.querySelector('img');
        const main = $('[data-main-image] img');
        if (main && img) { main.src = img.dataset.full || img.src; main.srcset = ''; }
        thumbs.forEach((t) => t.classList.remove('is-active'));
        firstVisible.classList.add('is-active');
      }
    };

    const findVariant = () => {
      const chosen = optionInputs().map((i) => i.value);
      return variants.find((v) => v.options.every((opt, idx) => opt === chosen[idx]));
    };

    const updateAvailability = () => {
      // grise les tailles indisponibles selon la couleur choisie (option 1)
      const groups = $$('.variant-options', form);
      if (groups.length < 2) return;
      const colorChecked = $('.variant-options--color input:checked', form);
      const sizeInputs = $$('.variant-options:not(.variant-options--color) input', form);
      if (!colorChecked || !sizeInputs.length) return;
      sizeInputs.forEach((sizeInput) => {
        const match = variants.find((v) => v.options[0] === colorChecked.value && v.options[1] === sizeInput.value);
        sizeInput.disabled = !(match && match.available);
      });
    };

    const update = () => {
      const v = findVariant();
      if (idInput && v) idInput.value = v.id;
      if (priceTarget && v) priceTarget.innerHTML = v.price_html || priceTarget.innerHTML;
      if (addBtn) {
        const ok = v && v.available;
        addBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');
        if (addBtnText) addBtnText.textContent = ok ? addBtn.dataset.textAdd : (v ? addBtn.dataset.textSoldout : addBtn.dataset.textUnavailable);
      }
      // galerie filtrée par la couleur sélectionnée
      const colorChecked = $('.variant-options--color input:checked', form);
      if (colorChecked) filterGalleryByColor(colorChecked.value);
      // met à jour l'URL (partage / retour)
      if (v && window.history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
    };

    form.querySelectorAll('.variant-options input').forEach((i) => on(i, 'change', () => { updateAvailability(); update(); }));
    updateAvailability();
    // filtrage initial de la galerie selon la couleur par défaut
    const initColor = $('.variant-options--color input:checked', form);
    if (initColor) filterGalleryByColor(initColor.value);
  });

  // Galerie : clic sur miniature
  $$('[data-thumb]').forEach((thumb) => on(thumb, 'click', () => {
    const main = $('[data-main-image]');
    const img = thumb.querySelector('img');
    if (main && img) {
      const mainImg = main.querySelector('img');
      mainImg.src = img.dataset.full || img.src;
      mainImg.srcset = '';
      $$('[data-thumb]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }
  }));

  /* ---------- 8. Guide des tailles (modal) ---------- */
  $$('[data-size-guide-open]').forEach((b) => on(b, 'click', () => {
    const dlg = $('#SizeGuideModal');
    if (dlg && dlg.showModal) dlg.showModal();
  }));
  $$('[data-size-guide-close]').forEach((b) => on(b, 'click', () => {
    const dlg = $('#SizeGuideModal');
    if (dlg) dlg.close();
  }));

  /* ---------- 8b. Onglets produits ---------- */
  $$('[data-tabs]').forEach((tabs) => {
    const btns = $$('.tabs__btn', tabs);
    const panels = $$('.tabs__panel', tabs);
    btns.forEach((btn) => on(btn, 'click', () => {
      const i = btn.getAttribute('data-tab');
      btns.forEach((b) => {
        const active = b.getAttribute('data-tab') === i;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-panel') === i));
    }));
  });

  /* ---------- 8b. Pastilles couleur des cartes produit ---------- */
  // Délégation : fonctionne aussi après un filtrage AJAX de la collection
  on(document, 'click', (e) => {
    const sw = e.target.closest('[data-swatch]');
    if (!sw) return;
    const card = sw.closest('.card');
    if (!card) return;
    const img = $('.card__img--main', card);
    if (img && sw.dataset.src) {
      img.src = sw.dataset.src;
      if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
      img.alt = sw.title;
    }
    if (sw.dataset.url) $$('a[href]', card).forEach((a) => { a.href = sw.dataset.url; });
    $$('[data-swatch]', card).forEach((s) => s.classList.toggle('is-active', s === sw));
    card.classList.add('has-swatch');
  });

  /* ---------- 9. Apparitions au scroll (légères) ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  }
})();
